import React from "react";
import Accessories from "../../components/HomeComponents/Accessories";
import BestSellerBrands from "../../components/HomeComponents/BestSellerBrands";
import CategoriesTop from "../../components/HomeComponents/CategoriesTop";
import ClothingCollection from "../../components/HomeComponents/ClothingCollection";
import DesignerOfWeek from "../../components/HomeComponents/DesignerOfWeek";
import Footwear from "../../components/HomeComponents/Footwear";
import HandBags from "../../components/HomeComponents/HandBags";
import NewArrivals from "../../components/HomeComponents/NewArrivals";
import ProductsRecent from "../../components/HomeComponents/ProductsRecent";
import TestimonialsSlider from "../../components/HomeComponents/TestimonialsSlider";
import TodaySalesBanner from "../../components/HomeComponents/TodaySalesBanner";
import Placeholder from "../../components/Placeholders/Placeholder";

function DesktopHome({ isLoading, elements }) {
  return (
    <>
      <div id="home-page">
        {/* {elements?.map((elementData, index) => {
      return renderElements(elementData, index);
    })} */}

        {/* Note: These elements are not rendered dynamically because in api not enough details are found 
    so implementing the same hard coded based on the index */}
        {/* Today Sales Sliding Banner */}
        {isLoading ? (
          <section className="banner home-banner mt-15 top-sales-banner">
            <div className="container-fluid mt-10">
              <div className="row">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
            </div>
          </section>
        ) : (
          <TodaySalesBanner
            componentData={elements[1] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}

        <div className="clearfix"></div>
        <div className="bottom-spacer-double"></div>
        <div className="clearfix"></div>

        {/* Top Category For Mobile */}
        {isLoading ? (
          <section className="collection-mobile d-mbl">
            <div className="container-fluid mt-10">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="circular"
                    width={100}
                    height={100}
                    className="mx-auto"
                  />

                  <Placeholder variant="text" width={100} className="mx-auto" />
                </div>

                <div className="col">
                  <Placeholder
                    variant="circular"
                    width={100}
                    height={100}
                    className="mx-auto"
                  />
                  <Placeholder variant="text" width={100} className="mx-auto" />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="circular"
                    width={100}
                    height={100}
                    className="mx-auto"
                  />
                  <Placeholder variant="text" width={100} className="mx-auto" />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <CategoriesTop
            componentData={elements[2] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}

        <div className="clearfix"></div>

        {/* Designer of Week Section */}
        {isLoading ? (
          <section className="designer-of-the-week spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <DesignerOfWeek
            componentData={elements[3] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}

        <div className="clearfix"></div>
        <div className="bottom-spacer"></div>
        <div className="clearfix"></div>

        {/* Clothing Collection Section */}
        {isLoading ? (
          <section className="clothing spacer">
            <div
              className="main-heading-center"
              style={{ marginBottom: "20px" }}
            >
              <h4>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h4>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
            </div>
          </section>
        ) : (
          <ClothingCollection
            componentData={elements[4] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}

        <div className="clearfix"></div>
        {/* <div className="bottom-spacer"></div> */}
        <div className="clearfix"></div>

        {/* Accessories Section */}
        {isLoading ? (
          <section className="accessories spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="main-heading-center mt-30">
                  <h4 className="">
                    <Placeholder
                      variant="text"
                      width={100}
                      className="mx-auto"
                    />
                  </h4>
                </div>
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>
              </div>

              <div className="row">
                <div className="main-heading-center mt-30">
                  <h4 className="">
                    <Placeholder
                      variant="text"
                      width={100}
                      className="mx-auto"
                    />
                  </h4>
                </div>
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section className="accessories spacer">
            <div className="main-heading-center bg-light">
              <h3>ACCESSORIES</h3>
            </div>
            <div className="container-fluid">
              <div className="row">
                {/* Men Accessories Section */}
                <Accessories
                  heading="MEN"
                  componentData={elements[5] || {}}
                  getTargetUrl={getTargetUrl}
                  showShopNow={true}
                />

                {/* Women Accessories Section */}
                <Accessories
                  heading="WOMEN"
                  componentData={elements[6] || {}}
                  getTargetUrl={getTargetUrl}
                  showShopNow={true}
                />
              </div>
            </div>
          </section>
        )}

        <div className="clearfix"></div>
        <div className="bottom-spacer"></div>
        <div className="clearfix"></div>

        {/* Handbags Section */}
        {isLoading ? (
          <section className="clothing spacer">
            <div
              className="main-heading-center"
              style={{ marginBottom: "20px" }}
            >
              <h4>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h4>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
              <div className="row mt-30">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
              <div className="row mt-30">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
            </div>
          </section>
        ) : (
          <HandBags
            componentData={elements[7] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}
        <div className="clearfix"></div>
        <div className="bottom-spacer"></div>
        <div className="clearfix"></div>

        {/* Footwear Section */}
        {isLoading ? (
          <section className="accessories spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <Footwear
            componentData={elements[8] || {}}
            getTargetUrl={getTargetUrl}
            showShopNow={true}
          />
        )}

        <div className="clearfix"></div>
        <div className="bottom-spacer"></div>
        <div className="clearfix"></div>

        {/* New Arrivals Section */}
        {isLoading ? (
          <section className="designer-of-the-week spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <NewArrivals
            componentData={elements[9] || {}}
            getTargetUrl={getTargetUrl}
          />
        )}

        <div className="clearfix"></div>
        <div className="bottom-spacer"></div>
        <div className="clearfix"></div>

        {/* Best Seller Brands Section */}
        {isLoading ? (
          <section className="designer-of-the-week spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder
                    variant="text"
                    width={200}
                    height={50}
                    className="mx-auto"
                  />
                  <Placeholder
                    variant="text"
                    width={"100%"}
                    className="mx-auto"
                  />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <BestSellerBrands
            componentData={elements[10] || {}}
            getTargetUrl={getTargetUrl}
            showShopNow={true}
          />
        )}

        <div className="clearfix"></div>
        <div className="bottom-spacer"></div>
        <div className="clearfix"></div>

        {/* Recently Viewed Section */}
        {isLoading ? (
          <section className="designer-of-the-week spacer">
            <div className="main-heading-center bg-light">
              <h3>
                <Placeholder variant="text" width={200} className="mx-auto" />
              </h3>
            </div>
            <div className="container-fluid mt-10">
              <div className="row">
                <div className="col">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />
                  <Placeholder variant="text" width={200} className="mx-auto" />
                  <Placeholder variant="text" width={200} className="mx-auto" />
                </div>

                <div className="col d-none d-sm-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder variant="text" width={200} className="mx-auto" />
                  <Placeholder variant="text" width={200} className="mx-auto" />
                </div>

                <div className="col d-none d-lg-block d-xl-block">
                  <Placeholder
                    variant="rectangular"
                    width={"100%"}
                    height={300}
                    className="mx-auto"
                  />

                  <Placeholder variant="text" width={200} className="mx-auto" />
                  <Placeholder variant="text" width={200} className="mx-auto" />
                </div>
              </div>
            </div>
          </section>
        ) : (
          <ProductsRecent componentData={elements[11] || {}} />
        )}

        <div className="clearfix"></div>
        <div className="bottom-spacer"></div>
        <div className="clearfix"></div>

        {/* Testimonials Section */}
        {isLoading ? (
          <section className="banner home-banner mt-15 top-sales-banner">
            <div className="container-fluid mt-10">
              <div className="row">
                <Placeholder
                  variant="rectangular"
                  width="100%"
                  height="400px"
                  style={{ marginLeft: "auto" }}
                />
              </div>
            </div>
          </section>
        ) : (
          <TestimonialsSlider componentData={elements[12] || {}} />
        )}
      </div>
    </>
  );
}

const getTargetUrl = (data) => {
  if (!data && !data.click_target) {
    return "#0";
  }

  if (data.click_target === "category") {
    const catId = data.url_path || "";
    return "/catalog/" + catId;
  }

  return "#0";
};

export default DesktopHome;
